/**
 * Accertify Data Collector
 * Captures device fingerprint data and syncs Transaction ID to cart attributes
 */

/**
 * Accertify window interface with device data collector
 * @typedef {Window & {
 *   accertify_tid?: string,
 *   _bcn?: {
 *     dvc: {
 *       getTID: () => string,
 *       setSubmissionCallback: (callback: () => void) => void
 *     }
 *   },
 * }} AccertifyWindow
 */

// STAGE URL
const DATA_COLLECTOR_URL = 'https://test.accdab.net/cdn/cs/WUWQmMNVRV4I3Iq65vKa6JqfTTA.js';

// PROD URL
// const DATA_COLLECTOR_URL = 'TBD';

const namespace = '[AccertifyDataCollector]';

function initAccertify() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = DATA_COLLECTOR_URL;
  script.id = 'bcn';
  script.setAttribute('dvc', 'a');
  script.onload = function () {
    const w = /** @type {AccertifyWindow} */ (window);
    if (w._bcn?.dvc) {
      w._bcn.dvc.setSubmissionCallback(registeredCallBack);
    }
  };
  document.head.appendChild(script);
}

async function registeredCallBack() {
  const w = /** @type {AccertifyWindow} */ (window);
  if (w._bcn?.dvc) {
    const tid = w._bcn.dvc.getTID();
    console.log(`${namespace} - Device data with transaction ID: ${tid} was received successfully`);
    if (tid && typeof fetch === 'function') {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { accertify_tid: tid } }),
      });
      w.accertify_tid = tid;
    }
  }
}

initAccertify();

/**
 * Wait for Accertify data collection to complete
 * Used in checkout-start.js
 */
export async function waitForAccertifyTID(timeout = 5000) {
  const startTime = Date.now();

  return new Promise((resolve) => {
    const checkInterval = setInterval(() => {
      const w = /** @type {AccertifyWindow} */ (window);

      if (w.accertify_tid) {
        clearInterval(checkInterval);
        console.info(`${namespace} - TID ready (cached): ${w.accertify_tid}`);
        resolve(true);
        return;
      }

      if (Date.now() - startTime >= timeout) {
        clearInterval(checkInterval);
        console.warn(`${namespace} - TID timeout after ${timeout}ms, proceeding anyway`);
        resolve(false);
      }
    }, 100);
  });
}
